import * as React from 'react';
import { Map } from 'immutable';
import ToolbarLine from './ToolbarLine';
function noop() { }
export default class Toolbar extends React.Component {
    constructor(props) {
        super(props);
        const map = {};
        props.plugins.forEach((plugin) => {
            map[plugin.name] = plugin;
        });
        this.pluginsMap = Map(map);
        this.state = {
            editorState: props.editorState,
            toolbars: [],
        };
    }
    renderToolbarItem(pluginName, idx) {
        const element = this.pluginsMap.get(pluginName);
        if (element && element.component) {
            const { component } = element;
            const props = {
                key: `toolbar-item-${idx}`,
                onClick: component.props ? component.props.onClick : noop,
            };
            if (React.isValidElement(component)) {
                return React.cloneElement(component, props);
            }
            return React.createElement(component, props);
        }
        return null;
    }
    conpomentWillReceiveProps() {
        this.render();
    }
    render() {
        const { toolbars, prefixCls } = this.props;
        return <div className={`${prefixCls}__toolbar`}>
      {toolbars.map((toolbar, idx) => {
            const children = React.Children.map(toolbar, this.renderToolbarItem.bind(this));
            return (<ToolbarLine key={`toolbar-${idx}`}>{children}</ToolbarLine>);
        })}
    </div>;
    }
}



// WEBPACK FOOTER //
// ./ext/editor-core/src/Toolbar/Toolbar.tsx